import { ReactNode } from 'react';
import ReactHelmet, { Helmet } from 'react-helmet';

interface ILoad {
  (param: string | string[]): ReactNode;
}

interface IGA {
  (param: string): ReactNode;
}

export const loadCSS: ILoad = (params) => {
  const cssList = typeof params === 'string'? [params]: params;
  return (
    <ReactHelmet link={cssList.map(cssName => ({
      type: "text/css",
      rel:  "stylesheet",
      href: `/resources/html/css/${cssName}.css`
    }))} />
  );
};

export const loadJS: ILoad = (params) => {
  const jsList = typeof params === 'string'? [params]: params;
  jsList.forEach(jsName => {
    const scriptTag = document.getElementById(jsName);
    scriptTag && scriptTag.remove();
  });
  return (
    <Helmet>
      {jsList.map(jsName =>
        <script id={jsName} key={jsName} src={`/resources/html/js/${jsName}.js`} />
      )}
    </Helmet>
  );
};


export const ga: IGA = (title) => {
  return (
    <Helmet>
      <meta name="ga:title" content={title} />
    </Helmet>
  );
};
